// extracted by mini-css-extract-plugin
export default {"divider":"LandingPage_divider__WkzAL"};